// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.palpitar-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.palpitar-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.btn-voltar-header {
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #333;
}

.btn-voltar-header:hover {
  border-color: #2196f3;
  color: #2196f3;
}

.palpitar-header h1 {
  margin: 0;
  font-size: 24px;
  color: white;
  flex: 1 1;
}

/* Banners */
.sucesso-banner,
.erro-banner,
.aviso-banner {
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-weight: 600;
  text-align: center;
}

.sucesso-banner {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #4caf50;
}

.sucesso-banner .subtexto {
  font-size: 12px;
  margin-top: 4px;
  opacity: 0.8;
}

.erro-banner {
  background: #ffebee;
  color: #c62828;
  border: 1px solid #f44336;
}

.aviso-banner {
  background: #fff3e0;
  color: #e65100;
  border: 1px solid #ff9800;
}

/* Card Principal */
.palpitar-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.jogo-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
}

.data-hora {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.data-hora .data {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.data-hora .hora {
  font-size: 16px;
  color: #333;
  font-weight: 700;
}

.grupo-badge {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

/* Confronto Grande */
.jogo-confronto-grande {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 32px;
  gap: 16px;
}

.selecao-grande {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  text-align: center;
}

.bandeira-grande {
  font-size: 64px;
  margin-bottom: 12px;
  line-height: 1;
}

.nome-selecao {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  line-height: 1.3;
}

.versus-grande {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
}

.versus-grande .vs-texto {
  font-size: 14px;
  color: #999;
  font-weight: 600;
  text-transform: uppercase;
}

/* Formulário */
.palpite-form {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 24px;
  padding: 24px;
  background: #f9f9f9;
  border-radius: 8px;
}

.form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
}

.input-group {
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  padding: 4px;
}

.btn-menos,
.btn-mais {
  background: white;
  border: none;
  width: 36px;
  height: 36px;
  font-size: 18px;
  font-weight: 700;
  color: #2196f3;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.btn-menos:hover,
.btn-mais:hover {
  background: #e3f2fd;
}

.btn-menos:active,
.btn-mais:active {
  background: #bbdefb;
}

.input-gols {
  flex: 1 1;
  border: none;
  background: white;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: #2196f3;
  outline: none;
}

.input-gols::-webkit-outer-spin-button,
.input-gols::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

.input-gols[type="number"] {
  appearance: textfield;
}

.versus-form {
  font-size: 24px;
  font-weight: 700;
  color: #999;
  margin-bottom: 8px;
}

/* Resumo do Palpite */
.palpite-resumo {
  text-align: center;
  padding: 20px;
  background: #f0f7ff;
  border-radius: 8px;
  margin-bottom: 24px;
  border: 2px solid #e3f2fd;
}

.titulo-resumo {
  margin: 0 0 12px 0;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
}

.resultado-palpite {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.gols-palpite {
  font-size: 36px;
  font-weight: 700;
  color: #2196f3;
  min-width: 48px;
  text-align: center;
}

.resultado-palpite .separador {
  font-size: 28px;
  color: #999;
  font-weight: 600;
}

/* Ações */
.form-actions {
  display: flex;
  gap: 12px;
}

.btn-cancelar,
.btn-salvar,
.btn-voltar,
.btn-voltar-full {
  flex: 1 1;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancelar {
  background: #f5f5f5;
  color: #666;
  border: 2px solid #e0e0e0;
}

.btn-cancelar:hover {
  background: #e8e8e8;
  border-color: #999;
}

.btn-salvar {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  color: white;
}

.btn-salvar:hover:not(:disabled) {
  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.btn-salvar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-voltar,
.btn-voltar-full {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  color: white;
}

.btn-voltar:hover,
.btn-voltar-full:hover {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
}

.btn-voltar-full {
  width: 100%;
}

/* Estados */
.carregando,
.erro-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  background: white;
  border-radius: 8px;
  padding: 40px 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2196f3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.carregando p,
.erro-container p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.erro-container {
  background: #fff3cd;
  border: 1px solid #ffc107;
}

.erro-container p {
  color: #856404;
  margin-bottom: 16px;
}

/* Responsivo */
@media (max-width: 600px) {
  .palpitar-container {
    padding: 12px;
  }

  .palpitar-header {
    flex-direction: column;
    align-items: stretch;
  }

  .palpitar-header h1 {
    text-align: center;
  }

  .palpitar-card {
    padding: 16px;
  }

  .palpite-form {
    flex-direction: column;
    padding: 16px;
  }

  .form-group {
    width: 100%;
  }

  .versus-form {
    order: 2;
    margin: 0;
  }

  .form-group:first-child {
    order: 1;
  }

  .form-group:last-child {
    order: 3;
  }

  .bandeira-grande {
    font-size: 48px;
  }

  .form-actions {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/paginas/PalpitarJogo.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;EACZ,SAAO;AACT;;AAEA,YAAY;AACZ;;;EAGE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;;EAGE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;EAIE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;;EAEE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA,YAAY;AACZ;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".palpitar-container {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 20px;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n}\n\n.palpitar-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.btn-voltar-header {\n  background: white;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: #333;\n}\n\n.btn-voltar-header:hover {\n  border-color: #2196f3;\n  color: #2196f3;\n}\n\n.palpitar-header h1 {\n  margin: 0;\n  font-size: 24px;\n  color: white;\n  flex: 1;\n}\n\n/* Banners */\n.sucesso-banner,\n.erro-banner,\n.aviso-banner {\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.sucesso-banner {\n  background: #e8f5e9;\n  color: #2e7d32;\n  border: 1px solid #4caf50;\n}\n\n.sucesso-banner .subtexto {\n  font-size: 12px;\n  margin-top: 4px;\n  opacity: 0.8;\n}\n\n.erro-banner {\n  background: #ffebee;\n  color: #c62828;\n  border: 1px solid #f44336;\n}\n\n.aviso-banner {\n  background: #fff3e0;\n  color: #e65100;\n  border: 1px solid #ff9800;\n}\n\n/* Card Principal */\n.palpitar-card {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.jogo-info-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.data-hora {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.data-hora .data {\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n}\n\n.data-hora .hora {\n  font-size: 16px;\n  color: #333;\n  font-weight: 700;\n}\n\n.grupo-badge {\n  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* Confronto Grande */\n.jogo-confronto-grande {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  margin-bottom: 32px;\n  gap: 16px;\n}\n\n.selecao-grande {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  text-align: center;\n}\n\n.bandeira-grande {\n  font-size: 64px;\n  margin-bottom: 12px;\n  line-height: 1;\n}\n\n.nome-selecao {\n  font-size: 14px;\n  font-weight: 700;\n  color: #333;\n  line-height: 1.3;\n}\n\n.versus-grande {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 60px;\n}\n\n.versus-grande .vs-texto {\n  font-size: 14px;\n  color: #999;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n/* Formulário */\n.palpite-form {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 24px;\n  background: #f9f9f9;\n  border-radius: 8px;\n}\n\n.form-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n}\n\n.input-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: white;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 4px;\n}\n\n.btn-menos,\n.btn-mais {\n  background: white;\n  border: none;\n  width: 36px;\n  height: 36px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #2196f3;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-radius: 4px;\n}\n\n.btn-menos:hover,\n.btn-mais:hover {\n  background: #e3f2fd;\n}\n\n.btn-menos:active,\n.btn-mais:active {\n  background: #bbdefb;\n}\n\n.input-gols {\n  flex: 1;\n  border: none;\n  background: white;\n  font-size: 24px;\n  font-weight: 700;\n  text-align: center;\n  color: #2196f3;\n  outline: none;\n}\n\n.input-gols::-webkit-outer-spin-button,\n.input-gols::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n.input-gols[type=\"number\"] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.versus-form {\n  font-size: 24px;\n  font-weight: 700;\n  color: #999;\n  margin-bottom: 8px;\n}\n\n/* Resumo do Palpite */\n.palpite-resumo {\n  text-align: center;\n  padding: 20px;\n  background: #f0f7ff;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  border: 2px solid #e3f2fd;\n}\n\n.titulo-resumo {\n  margin: 0 0 12px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n}\n\n.resultado-palpite {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.gols-palpite {\n  font-size: 36px;\n  font-weight: 700;\n  color: #2196f3;\n  min-width: 48px;\n  text-align: center;\n}\n\n.resultado-palpite .separador {\n  font-size: 28px;\n  color: #999;\n  font-weight: 600;\n}\n\n/* Ações */\n.form-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-cancelar,\n.btn-salvar,\n.btn-voltar,\n.btn-voltar-full {\n  flex: 1;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-cancelar {\n  background: #f5f5f5;\n  color: #666;\n  border: 2px solid #e0e0e0;\n}\n\n.btn-cancelar:hover {\n  background: #e8e8e8;\n  border-color: #999;\n}\n\n.btn-salvar {\n  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);\n  color: white;\n}\n\n.btn-salvar:hover:not(:disabled) {\n  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);\n}\n\n.btn-salvar:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-voltar,\n.btn-voltar-full {\n  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);\n  color: white;\n}\n\n.btn-voltar:hover,\n.btn-voltar-full:hover {\n  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);\n}\n\n.btn-voltar-full {\n  width: 100%;\n}\n\n/* Estados */\n.carregando,\n.erro-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  background: white;\n  border-radius: 8px;\n  padding: 40px 20px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #2196f3;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.carregando p,\n.erro-container p {\n  margin: 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.erro-container {\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n}\n\n.erro-container p {\n  color: #856404;\n  margin-bottom: 16px;\n}\n\n/* Responsivo */\n@media (max-width: 600px) {\n  .palpitar-container {\n    padding: 12px;\n  }\n\n  .palpitar-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .palpitar-header h1 {\n    text-align: center;\n  }\n\n  .palpitar-card {\n    padding: 16px;\n  }\n\n  .palpite-form {\n    flex-direction: column;\n    padding: 16px;\n  }\n\n  .form-group {\n    width: 100%;\n  }\n\n  .versus-form {\n    order: 2;\n    margin: 0;\n  }\n\n  .form-group:first-child {\n    order: 1;\n  }\n\n  .form-group:last-child {\n    order: 3;\n  }\n\n  .bandeira-grande {\n    font-size: 48px;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
